import {modalContactEventPush} from "./components/modalEventPush";
import modalResponseRender from "./components/modalResponseRender";
import modalSpinner from "./components/modalSpinner";
import addModalUrlAutoComplete from './components/modalAutoComplete';
import getCookies from './components/getCookies';

import { 
  parseCountryValue, 
  validatePhoneNumber, 
  initCountryCodeDisplay 
} from './components/phoneValidation';

initCountryCodeDisplay();


export default function setContactModalHandlers(wpcfModalSelector) {
    let wpcfModalEventLabel = $(wpcfModalSelector).data('event-slug');

    let dataAttributesList = $(wpcfModalSelector).data();
    let customResponse = $(wpcfModalSelector).data('custom-response');

    let wpcfModalNativeSelectors = document.querySelectorAll(`${wpcfModalSelector} .form-holder>.wpcf7`);
    if (!wpcfModalNativeSelectors) return;
    let isNotSentModalForm = true;

    // Глобальная переменная в рамках модуля, чтобы хранить состояние для текущей открытой модалки
    let activeFormShouldUseCalendly = false;

// Слушаем клик по всем кнопкам, которые открывают модалки
    $(document).on('click', '[data-bs-toggle="modal"]', function() {
        const useCalendly = $(this).data('calendly'); // берем значение из нашего нового атрибута
        activeFormShouldUseCalendly = (useCalendly === true || useCalendly === "true");

        console.log('Calendly active for this session:', activeFormShouldUseCalendly);
    });

    $(wpcfModalSelector).on('show.bs.modal', function () {

        import(/* webpackChunkName: "chunk.select2" */ 'select2').then(() => {
            $(`${wpcfModalSelector} select.form-control.select2-search`).select2({
                dropdownParent: $(wpcfModalSelector),
                minimumResultsForSearch: 1
            });

            $(`${wpcfModalSelector} select.form-control`).not(".select2-search").select2({
                minimumResultsForSearch: -1
            });
        });

        $.get("https://ipinfo.io", function (response) {
            $(wpcfModalSelector).find('[name=user-ip]')
                .val(response.ip);
        }, "jsonp");

        if (document.cookie.indexOf('eos_user_id=') >= 0) {
            $.ajax({
                type: 'GET',
                xhrFields: {withCredentials: true},
                url: 'https://auth.eos.com/account/details/',
                success: function (response) {

                    let user_name = $(wpcfModalSelector).find('[name=user-name]');
                    let first_name = $(wpcfModalSelector).find('[name=first-name]');
                    let last_name = $(wpcfModalSelector).find('[name=last-name]');
                    let email = $(wpcfModalSelector).find('[name=user-email]');


                    if (response.first_name) {
                        first_name.val(response.first_name).parent().parent('.form-field').addClass('not-empty');
                    }

                    if (response.last_name) {
                        last_name.val(response.last_name).parent().parent('.form-field').addClass('not-empty');
                    }

                    if (response.first_name && response.last_name) {

                        user_name.val(response.first_name + ' ' + response.last_name).parent().parent('.form-field').addClass('not-empty');
                    }

                    if (response.email) {
                        email.val(response.email).parent().parent('.form-field').addClass('not-empty');
                    }
                },
            })
        }
    });

    $(wpcfModalSelector).on('hide.bs.modal', function () {

        $('html').removeClass('modal-open');

        if (isNotSentModalForm) {
            modalContactEventPush(wpcfModalSelector, 'Close', wpcfModalEventLabel);
        } else {
            isNotSentModalForm = true;
        }

        $(wpcfModalSelector).find('.form-field').removeClass('not-empty disabled');
        $(wpcfModalSelector).find('[readonly]').attr("readonly", false);

        wpcfModalNativeSelectors.forEach(function (wpcfModalNativeSelector) {
            let wpcfFormNativeSelector = wpcfModalNativeSelector.querySelector('form');
            if (!wpcfFormNativeSelector) return;
            wpcfFormNativeSelector.reset();
        });

        // sessionStorage.removeItem(wpcfModalSelector);
    });

    $(wpcfModalSelector).on('shown.bs.modal', function () {
        let modalData = JSON.parse(sessionStorage.getItem(wpcfModalSelector));
        if (modalData) {
            let modalDisabledFields = modalData['modal-disabled'];
            let modalAutocompleteFields = modalData['modal-autocomplete'];

            for (const property in modalAutocompleteFields) {
                let field = $(wpcfModalSelector).find(`[name=${property}]`);
                if (field.is('select')) {
                    field.val(modalAutocompleteFields[property]).trigger("change");
                    field.parent().parent('.form-field').addClass('not-empty');
                } else {
                    field
                        .val(modalAutocompleteFields[property])
                        .parent().parent('.form-field').addClass('not-empty');
                }
            }

            for (const property in modalDisabledFields) {
                $(wpcfModalSelector)
                    .find(`[name=${property}]`)
                    .attr('readonly', modalDisabledFields[property])
                    .parent().parent().addClass('disabled');
            }
        }

        modalContactEventPush(wpcfModalSelector, 'Show', wpcfModalEventLabel);

    });


    wpcfModalNativeSelectors.forEach(function (wpcfModalNativeSelector) {

        let wpcfFormNativeSelector = wpcfModalNativeSelector.querySelector('form');
        if (!wpcfFormNativeSelector) return;

        wpcfFormNativeSelector.addEventListener("submit", function (event) {
            const $form = $(event.target);
            const $phone = $form.find("[name=phone-number]");

            const rawCountry = $form.find("[name=country-code]").val() || "";
            const { iso, isOther } = parseCountryValue(rawCountry);
            const phone = ($phone.val() || "").trim();

            const validation = validatePhoneNumber(phone, iso, isOther);

            $phone.removeClass("wpcf7-not-valid");
            $phone.closest(".wpcf7-form-control-wrap").find(".wpcf7-not-valid-tip").remove();

            if (!validation.isValid) {

                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                $phone.addClass("wpcf7-not-valid");
                $phone.closest(".wpcf7-form-control-wrap").append(
                    '<span class="wpcf7-not-valid-tip">Invalid phone number</span>'
                );

                return false;
            }

            modalContactEventPush(wpcfModalSelector, "submit");
            modalSpinner(wpcfModalSelector, "start");

            $phone.val(validation.formatted);

            return true;
        });

        wpcfModalNativeSelector.addEventListener('change', function (event) {
            if (!event.target.matches('[name=constent-checkbox]')) return;

            const $form = $(event.target).closest('form');
            const $phone = $form.find('[name=phone-number]');
            
            const rawCountry = $form.find('[name=country-code]').val() || '';
            const { iso, isOther } = parseCountryValue(rawCountry);
            const validation = validatePhoneNumber($phone.val().trim(), iso, isOther);

            const $wrap = $phone.closest('.wpcf7-form-control-wrap');

            $phone.removeClass('wpcf7-not-valid');
            $wrap.find('.wpcf7-not-valid-tip').remove();

            if (!validation.isValid) {
                $phone.addClass('wpcf7-not-valid');
                $wrap.append('<span class="wpcf7-not-valid-tip">Invalid phone number</span>');
            }
        });

        wpcfModalNativeSelector.addEventListener('wpcf7mailsent', function (event) {
            isNotSentModalForm = false;

            const isTargetModal = event.target.closest('#modalEosContactUs');

            function getProductname() {
                if (wpcfModalSelector === '#modalRegistrationSingleForm' || wpcfModalSelector === '#modalRegistrationGroupForm') {
                    let productSelected = wpcfModalNativeSelector.querySelector('form select[name="product"]');
                    let productSelectedValue = productSelected.options[productSelected.selectedIndex].value;
                    if (productSelectedValue === 'EOSDA Crop Monitoring') return 'cm';
                    if (productSelectedValue === 'EOSDA LandViewer') return 'lv';
                }
                return;
            }

            const inputs = event.detail.inputs;
            const email = inputs.find(i => i.name === 'user-email')?.value.toLowerCase() || '';
            const firstName = inputs.find(i => i.name === 'first-name')?.value || '';
            const lastName = inputs.find(i => i.name === 'last-name')?.value || '';
            const company = inputs.find(i => i.name === 'company-name')?.value || '';
            const industry = inputs.find(i => i.name === 'industry')?.value || '';
            const message = inputs.find(i => i.name === 'message')?.value || '';
            const countryCode = inputs.find(i => i.name === 'country-code')?.value || '';
            const phoneRaw = inputs.find(i => i.name === 'phone-number')?.value || '';
            const userIp = $(wpcfModalSelector).find('[name=user-ip]').val();

            const blockedDomains = [
                '.edu', '.ac.', 'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'aol.com',
                'live.com', 'msn.com', 'icloud.com', 'me.com', 'mac.com',
                'protonmail.com', 'proton.me', 'pm.me', 'tutanota.com',
                'mail.ru', 'yandex.ru', 'rambler.ru', 'list.ru', 'bk.ru', 'inbox.ru',
                'gmx.de', 'web.de', 't-online.de', 'wp.pl', 'onet.pl', 'seznam.cz',
                'orange.fr', 'free.fr', 'libero.it', 'virgilio.it', 'uol.com.br',
                'qq.com', '163.com', '126.com', 'sina.com', 'rediffmail.com', 'yahoo.co.jp'
            ];
            const isPublicEmail = blockedDomains.some(domain => email.includes(domain));

            let isFinished = false;
            const finishSubmission = () => {
                if (isFinished) return;
                isFinished = true;

                modalResponseRender(event, dataAttributesList, customResponse);
                modalContactEventPush(wpcfModalSelector, 'Success', wpcfModalEventLabel, getProductname());
                modalSpinner(wpcfModalSelector, 'stop');
                $(wpcfModalSelector).modal('hide');
                $('.form-upload-file').removeClass('active');
            };

            if (isTargetModal && !isPublicEmail && userIp && window.Calendly) {
                fetch(`https://ipapi.co/${userIp}/json/`)
                    .then(res => res.json())
                    .then(data => {
                        const allowedCountries = ['CA', 'AR', 'BR', 'US', 'AU', 'MX', 'FR', 'DE', 'IT', 'ES', 'PT', 'GB', 'AE', 'QA', 'OM', 'BH', 'KW'];

                        if (allowedCountries.includes(data.country_code)) {
                            $(wpcfModalSelector).modal('hide');
                            $('.modal-backdrop').remove();
                            $('body').removeClass('modal-open');

                            const calendlyHandler = (e) => {
                                if (e.data.event === 'calendly.close_widget') {
                                    finishSubmission();
                                    window.removeEventListener('message', calendlyHandler);
                                }
                            };
                            window.addEventListener('message', calendlyHandler);

                            const observer = new MutationObserver((mutations) => {
                                if (!document.querySelector('.calendly-overlay')) {
                                    finishSubmission();
                                    observer.disconnect();
                                }
                            });
                            observer.observe(document.body, {childList: true});

                            // let calendlyUrl = 'https://calendly.com/evgenii-fesenko-eosda/30min';
                            let calendlyUrl = 'https://calendly.com/anastasiia-yovyk-eosda/30min';

                            setTimeout(() => {
                                Calendly.initPopupWidget({
                                    url: calendlyUrl,
                                    prefill: {
                                        firstName: firstName,
                                        lastName: lastName,
                                        email: email,
                                        customAnswers: {
                                            a1: company,
                                            a2: industry,
                                            a3: phoneRaw,
                                            a4: message
                                        }
                                    }
                                });
                            }, 200);

                        } else {
                            finishSubmission();
                        }
                    })
                    .catch(() => finishSubmission());
            } else {
                finishSubmission();
            }
        }, false);


        wpcfModalNativeSelector.addEventListener('wpcf7mailfailed', function (event) {
            isNotSentModalForm = false;
            modalResponseRender(event, dataAttributesList);
            modalContactEventPush(wpcfModalSelector, 'error_server', wpcfModalEventLabel, false, `status - ${event.detail.status}`);
            modalSpinner(wpcfModalSelector, 'stop');
            $(wpcfModalSelector).modal('hide');
        }, false);

        wpcfModalNativeSelector.addEventListener('wpcf7spam', function (event) {
            isNotSentModalForm = false;
            modalResponseRender(event, dataAttributesList);
            modalContactEventPush(wpcfModalSelector, 'error_spam', wpcfModalEventLabel, false, `status - ${event.detail.status}`)
            modalSpinner(wpcfModalSelector, 'stop');
            $(wpcfModalSelector).modal('hide');
        }, false);

        wpcfModalNativeSelector.addEventListener('wpcf7invalid', function (event) {
            let arr = [];
            let eventContent = [];
            event.detail.apiResponse.invalid_fields.map(item => arr.push(item.field));
            const getValue = (key) => event.detail.inputs.find(el => el.name == key) ? event.detail.inputs.find(el => el.name == key).value : '';
            for (let i = 0; i < arr.length; i++) eventContent.push(`${arr[i]} - ${getValue(arr[i])}`);
            modalContactEventPush(wpcfModalSelector, 'error_invalidation', wpcfModalEventLabel, false, eventContent.join(', '));
            modalSpinner(wpcfModalSelector, 'stop');
        }, false);
    });

    addModalUrlAutoComplete(wpcfModalSelector);
}

(function() {
    let isCloseEventSent = false;
    let isCalendlyStepReached = false;
    const lastSentEvents = {};

    function pushToEosDataLayer(action, label = '', position = '') {
        const now = Date.now();
        if (lastSentEvents[action] && (now - lastSentEvents[action] < 1000)) return;
        lastSentEvents[action] = now;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'EOSCOM',
            'eventCategory': 'EosComEvents',
            'eventAction': action,
            'eventLabel': label,
            'eventPosition': position,
            'eventContext': ''
        });
        console.log(`✅ GA Event Sent: ${action}`);
    }

    function getSavedButtonData() {
        try {
            const parsed = JSON.parse(sessionStorage.getItem('#modalEosContactUs'));
            return parsed?.['events-form'] || { eventLabel: '', eventPosition: '' };
        } catch (e) { return { eventLabel: '', eventPosition: '' }; }
    }

    function handleManualClose() {
        if (!isCloseEventSent && isCalendlyStepReached) {
            const buttonData = getSavedButtonData();
            isCloseEventSent = true;
            pushToEosDataLayer('calendly_form_close', buttonData.eventLabel, buttonData.eventPosition);

            setTimeout(() => {
                isCloseEventSent = false;
                isCalendlyStepReached = false;
            }, 1500);
        }
    }

    window.addEventListener('message', function(e) {
        if (e.data.event && e.data.event.indexOf('calendly') === 0) {
            const buttonData = getSavedButtonData();
            isCalendlyStepReached = true;

            switch (e.data.event) {
                case 'calendly.event_type_viewed':
                    pushToEosDataLayer('calendly_form_show', buttonData.eventLabel, buttonData.eventPosition);
                    break;
                case 'calendly.date_and_time_selected':
                    pushToEosDataLayer('calendly_form_picked_datetime', buttonData.eventLabel, buttonData.eventPosition);
                    break;
                case 'calendly.event_scheduled':
                    pushToEosDataLayer('calendly_form_success', buttonData.eventLabel, buttonData.eventPosition);
                    break;
                case 'calendly.close_widget':
                    handleManualClose();
                    break;
            }
        }
    });

    const observer = new MutationObserver((mutations) => {
        if (isCalendlyStepReached && !document.querySelector('.calendly-overlay') && !isCloseEventSent) {
            handleManualClose();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    jQuery(document).ready(function($) {
        $('#modalEosContactUs').on('hide.bs.modal', function () {
            if (isCalendlyStepReached && !isCloseEventSent) {
                handleManualClose();
            }
        });

        $('#modalEosContactUs').on('show.bs.modal', function () {
            isCloseEventSent = false;
            isCalendlyStepReached = false;
        });
    });
})();
